import { render, staticRenderFns } from "./ys-nameplate.vue?vue&type=template&id=79d46476&scoped=true"
var script = {}
import style0 from "./ys-nameplate.vue?vue&type=style&index=0&id=79d46476&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79d46476",
  null
  
)

export default component.exports